export default "__VITE_ASSET__B9T4wSHm__"